module.exports = __webpack_public_path__ + "static/TT-Plans-BART-b066694e2465dd32494aa0e38c7b7f15.jpg";